import {
  ChatBrowserMessage,
  ChatEntityType,
  ChatPlayer,
  ChatVehicle,
} from "@/domains/chat/constants/chat";

export default function findMessageUids(
  messages: ChatBrowserMessage[],
  searchText: string,
): string[] {
  if (!searchText.trim()) {
    return [];
  }

  const searchLower = searchText.toLowerCase();
  const foundUids: string[] = [];

  messages.forEach((message) => {
    if (message.message.content?.toLowerCase().includes(searchLower)) {
      foundUids.push(message.uid);
      return;
    }

    if (message.player?.name?.toLowerCase().includes(searchLower)) {
      foundUids.push(message.uid);
      return;
    }

    if (
      message.message.template &&
      String(message.message.template).toLowerCase().includes(searchLower)
    ) {
      foundUids.push(message.uid);
      return;
    }

    message.message.entities.forEach((entity) => {
      if (entity.type === ChatEntityType.Player) {
        const player = entity.content as ChatPlayer;
        if (player.name?.toLowerCase().includes(searchLower)) {
          foundUids.push(message.uid);
        }
      } else if (entity.type === ChatEntityType.Vehicle) {
        const vehicle = entity.content as ChatVehicle;
        if (vehicle.name?.toLowerCase().includes(searchLower)) {
          foundUids.push(message.uid);
        }
      }
    });
  });

  return foundUids;
}
